import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const ROLE_OPTIONS = [
  { value: 'admin', label: 'Admin/Owner' },
  { value: 'center_manager', label: 'Center Manager Sales' },
  { value: 'center_manager_ops', label: 'Center Manager Ops' },
  { value: 'sales', label: 'Sales' },
  { value: 'operations', label: 'Operations' },
];

const BulkActionsPanel = ({ selectedCount, centers, onBulkRoleUpdate, onBulkCenterAssign, onClearSelection, loading }) => {
  const [bulkRole, setBulkRole] = useState('');
  const [bulkCenterId, setBulkCenterId] = useState('');
  const [showRolePanel, setShowRolePanel] = useState(false);
  const [showCenterPanel, setShowCenterPanel] = useState(false);

  const handleBulkRole = async () => {
    if (!bulkRole) return;
    await onBulkRoleUpdate?.(bulkRole);
    setBulkRole('');
    setShowRolePanel(false);
  };

  const handleBulkCenter = async () => {
    if (!bulkCenterId) return;
    await onBulkCenterAssign?.(bulkCenterId);
    setBulkCenterId('');
    setShowCenterPanel(false);
  };

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-full bg-blue-600 flex items-center justify-center">
            <span className="text-xs font-bold text-white">{selectedCount}</span>
          </div>
          <span className="text-sm font-medium text-blue-900">{selectedCount} user{selectedCount !== 1 ? 's' : ''} selected</span>
        </div>
        <div className="flex flex-wrap items-center gap-2 ml-auto">
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => { setShowRolePanel(!showRolePanel); setShowCenterPanel(false); }}
            className="flex items-center gap-1.5"
          >
            <Icon name="Shield" size={14} />
            Bulk Role Update
          </Button>
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => { setShowCenterPanel(!showCenterPanel); setShowRolePanel(false); }}
            className="flex items-center gap-1.5"
          >
            <Icon name="Building" size={14} />
            Assign to Center
          </Button>
          <button
            onClick={onClearSelection}
            className="text-sm text-blue-600 hover:text-blue-800 font-medium px-2"
          >
            Clear
          </button>
        </div>
      </div>

      {showRolePanel && (
        <div className="mt-3 pt-3 border-t border-blue-200 flex flex-wrap items-center gap-3">
          <span className="text-sm font-medium text-blue-900">Set role for all selected:</span>
          <Select
            value={bulkRole}
            onChange={(e) => setBulkRole(e?.target?.value)}
            className="w-56"
          >
            <option value="">Select a role...</option>
            {ROLE_OPTIONS?.map((opt) => (
              <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
            ))}
          </Select>
          <Button
            type="button"
            variant="primary"
            size="sm"
            onClick={handleBulkRole}
            disabled={!bulkRole || loading}
          >
            {loading ? 'Updating...' : 'Apply Role'}
          </Button>
        </div>
      )}

      {showCenterPanel && (
        <div className="mt-3 pt-3 border-t border-blue-200 flex flex-wrap items-center gap-3">
          <span className="text-sm font-medium text-blue-900">Assign all selected to center:</span>
          <Select
            value={bulkCenterId}
            onChange={(e) => setBulkCenterId(e?.target?.value)}
            className="w-64"
          >
            <option value="">Select a center...</option>
            {centers?.map((c) => (
              <option key={c?.id} value={c?.id}>{c?.name}</option>
            ))}
          </Select>
          <Button
            type="button"
            variant="primary"
            size="sm"
            onClick={handleBulkCenter}
            disabled={!bulkCenterId || loading}
          >
            {loading ? 'Assigning...' : 'Assign Center'}
          </Button>
        </div>
      )}
    </div>
  );
};

export default BulkActionsPanel;
